
import { ReactNode } from 'react';
import AdminSidebar from './AdminSidebar';
import { SidebarProvider, SidebarTrigger } from './ui/sidebar';
import { ProtectedAdminRoute } from './ProtectedAdminRoute';

interface AdminLayoutProps {
  children: ReactNode;
  pageTitle: string;
  pageDescription: string;
}

export default function AdminLayout({ children, pageTitle }: AdminLayoutProps) {
  return (
    <ProtectedAdminRoute>
      <SidebarProvider defaultOpen={true}>
        <div className="flex h-screen bg-background w-full">
          <AdminSidebar />
          <MainContent pageTitle={pageTitle}>
            {children}
          </MainContent>
        </div>
      </SidebarProvider>
    </ProtectedAdminRoute>
  );
}

function MainContent({ children, pageTitle }: { children: ReactNode; pageTitle: string }) {
  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <header className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="h-14 sm:h-16 flex items-center px-3 sm:px-4 lg:px-6 gap-3 sm:gap-4">
          <div className="md:hidden">
            <SidebarTrigger />
          </div>
          <div className="flex-1 min-w-0">
            <h1 className="text-base sm:text-lg lg:text-xl font-semibold truncate">{pageTitle}</h1>
          </div>
        </div>
      </header>
      <main className="flex-1 overflow-y-auto bg-muted/30">
        <div className="h-full p-3 sm:p-4 lg:p-6">
          {children}
        </div>
      </main>
    </div>
  );
}
